<template>
  <layout-card-wrap
    v-loading="loading"
    hasSlot>
    <template slot="title">所有品牌</template>
    <div slot="form">
      <category-select v-model="config.categoryId" />
      <el-button
        style="margin-left:10px;"
        type="primary"
        @click="fetchList">查询</el-button>
    </div>
    <el-table
      border
      :data="listNew">
      <el-table-column
        label="品类名称"
        width="120"
        prop="categoryName"></el-table-column>
      <el-table-column
        label="品牌名称"
        min-width="200"
        prop="blandName"></el-table-column>
      <el-table-column
        label="库存数量"
        min-width="100"
        prop="totalStockBalance"></el-table-column>
    </el-table>
    <el-pagination
      slot="footer"
      background
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange"></el-pagination>
  </layout-card-wrap>
</template>

<script>
import Ai from '@/service/ai'
import CategorySelect from '@/pages/appraisal/order/category-select.vue'
export default {
  name: 'BrandCountTable',
  components: { CategorySelect },
  props: {
    option: { type: Object, default() { return {} } }
  },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10 }
    }
  },
  computed: {
    listNew({ list, config }) {
      const { pageNum, pageSize } = config
      return list.slice((pageNum - 1) * pageSize, pageNum * pageSize)
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Ai.getcategoryblandinventorys({ ...this.config, ...this.option })
        .then(res => {
          this.loading = false
          const { result, message, data } = res.data
          if (result === 0) {
            this.list = data
            this.total = data.length
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }

}
</script>
